hrd.dashboard.dashlet.adjustPanelSize = function (contentId, containerId, headerId, footerId) {
	var headerHeight = (headerId && $(headerId).exists() && $(headerId).is(':visible')) ? ($(headerId).outerHeight()) : 0;
	var footerHeight = (footerId && $(footerId).exists() && $(footerId).is(':visible')) ? ($(footerId).outerHeight(true)) : 0;
	var contentHeight = $(contentId).height() + $(containerId).height() - headerHeight - $(contentId).outerHeight() - footerHeight;
	$(contentId).height(contentHeight);
	/* width computing seems not needed anymore */
	//$(contentId).width( $(contentId).width()  + $(containerId).width()  - $(contentId).outerWidth());
};

hrd.dashboard.dashlet.adjustTabHeight = function (tab, tabContainer){
	var $tab = $(tab);
	var tabMBP = $tab.outerHeight(true) - $tab.height(); // vertical margins, borders, paddings
	$tab.height($(tabContainer).innerHeight() - tabMBP);
};

hrd.dashboard.dashlet.resize = function(redrawTables){
	hrd.dashboard.dashlet.fieldCompositeLayout(4);
};

/**
 * Invoked only in old-styled dashboards.
 * Added a check in order to apply only for visible elements
 */
hrd.dashboard.dashlet.fieldCompositeLayout = function(adjust) {
	// added visibility check
	$('.field-composite:visible:not(.skip-layout)').each(function(i, div){
		adjust = adjust || 10;
		var $div = $(div); //.field-composite
		var $label =  $('label', $div).eq(0);
		var $input = $('input', $div).eq(0);
		if($input){
			var iw = $div.width() - $label.outerWidth(true) - ($input.outerWidth(true) - $input.width()) - adjust;
			$input.width(iw);
		}
		var $select = $('select', $div).eq(0);
		if($select){
			var iw = $div.width() - $label.outerWidth(true) - ($select.outerWidth(true) - $select.width()) - adjust;
			$select.width(iw);
		}
		var $innerDiv = $('div', $div).eq(0);
		if($innerDiv){
			if($innerDiv.hasClass('full-width')){
				$innerDiv.width('100%');
			} else {
				var iw = $div.width() - $label.outerWidth(true) - ($innerDiv.outerWidth(true) - $innerDiv.width()) - adjust;
				$innerDiv.width(iw);
			}
		}
	});
};

/**
 * Metodo usato per
 * 		- allineare tutte le label a destra dando a tutte la stessa lunghezza, con eventuale lunghezza minima.
 * 				la massima sarà la massima parola + un delta configurabile
 * 		- dare alla parte destra (campo/select/div) la massima larghezza disponibile di quella avanzata dopo passo precedente
 */
hrd.dashboard.dashlet.arrangeFieldSet = function(container, options) {
	var settings = {
		size: '1x',
		extraWidth : 8,
		ignoreClasses: 'form-error'
	};
	if (options) {
		$.extend(settings, options);
	}

	switch (settings.size) {
	case '2x':
		$('.dashlet-fieldset .field-composite', $(container)).addClass('field-composite-2x')
		$('.dashlet-fieldset .dashlet-legend', $(container)).addClass('dashlet-legend-2x')
		break;
	}

	var labelsWidth = $('.dashlet-fieldset .field-composite > label:not(.ignore-aw)', $(container)).autoWidth(settings);
	$('.dashlet-fieldset .read-only-data, .dashlet-fieldset .editable-data, .dashlet-fieldset .button-bar-container', $(container)).fillHorizontalSpace(settings);
	return {
		labelsWidth: labelsWidth
	};
};
